// extracted by mini-css-extract-plugin
export var Button = "Button-module--Button--vmP5N";
export var ButtonFullwidth = "Button-module--ButtonFullwidth--VpUxS";
export var ButtonLarge = "Button-module--ButtonLarge--1OJrI";
export var ButtonPrimary = "Button-module--ButtonPrimary--5QSCs";
export var ButtonSecondary = "Button-module--ButtonSecondary--Buxd9";
export var ButtonWhite = "Button-module--ButtonWhite--d8W91";